import React from 'react';

// The app-wide Value Year control. ⛔ ONE CONTROL, ONE KEY: `onChange` must be StaffPortal's
// setValueYear, the only writer of sessionStorage 'wh_valueYear'. Choosing a year here moves the
// parcel modal's opening year, the retirement gating on the Parcels list and PropertiesGrid, the
// per-year appeal status / deadline / services, and the Clients-page counts — it is not a local filter.
//
// Extracted from the property drill (StaffPortal, added in 70d366a) when the Properties page needed
// the same control. Two call sites, deliberately kept to markup + the option loop: everything that
// differs between them is passed in.
//
// ⛔ optionChip IS OPTIONAL BECAUSE IT IS NOT ALWAYS ANSWERABLE. On one property, "is 2025 baseline?"
// has an answer and the chip states it. On a LIST of properties it does not: with one property's
// first_year at 2026 and three others earlier, 2025 is baseline for some and represented for others,
// and a single '·baseline' would be a wrong answer wearing a helpful shape. So the Properties page
// passes nothing rather than passing something approximate — a bare year is honest, a mislabelled
// one is not. Do NOT add a default chip here; the absence is the decision.
//
// The Clients page deliberately has NO year selector: its property list does not gate by year at all
// (docs/known-debt.md), so a control here would imply a scoping that does not exist. Gating it first
// is a behavioural decision about what account managers see, not a UI extraction.
export default function ValueYearSelect({ years, value, onChange, optionChip, s, c, label = 'Value Year' }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginLeft: 'auto' }}>
      <span style={{ fontSize: '10px', fontWeight: '700', color: c.muted, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{label}</span>
      <select value={value} onChange={e => onChange(e.target.value)}
        style={{ ...s.input, width: 'auto', padding: '5px 9px', fontSize: '12px' }}>
        {(years || []).map(y => {
          // ⛔ THE SAME REASON HELPER THE PARCEL TABS AND THE BANNER USE, when one is supplied. A
          // property with a first_year must not read '·retired' for the years before it — nothing was
          // retired, we had not started.
          const ch = optionChip ? optionChip(y) : null;
          return <option key={y} value={y} title={ch ? ch.title : ''}>{y}{ch && ch.tag ? ` ${ch.tag}` : ''}</option>;
        })}
      </select>
    </div>
  );
}
